import React from 'react'
import styles from './BinanaceNFTTickets.module.scss'
import { Row, Col } from 'react-bootstrap'
import goldTicket from '../../assets/imgs/binanceNFT/gold-ticket-transparent.png'
import silverTicket from '../../assets/imgs/binanceNFT/silver-ticket-transparent.png'
import bronzeTicket from '../../assets/imgs/binanceNFT/bronze-ticket-transparent.png'
import busdIcon from '../../assets/imgs/binanceNFT/icon-busd.png';

const BinanaceNFTTickets = () => {
    return (
        <section className={styles.tickets_container}>
            <div className={styles.tickets_header}>
                <h3>Tickets</h3>
                <p>
                    Owner of TOWER Tickets will be able to redeem Game card NFTs for the upcoming TOWER PC blockchain <br /> 
                    Game, and Crazy Defense Heroes starter packages that help you progress faster on the Mobile game
                </p>
            </div>
            <div className={styles.ticketItem_container}>
                <Row className='mx-0 my-0'>
                    <Col sm={12} lg={4} className={styles.ticket_col}>
                        <div className={styles.ticket_item}>
                            <div className={styles.ticket_img}>
                                <img src={goldTicket} alt="gold ticket" />
                            </div>
                            <div className={styles.ticket_desc}>
                                <h3 className={styles.ticket_title}>
                                    Gold Ticket
                                </h3>
                                <p className={styles.ticket_info}>
                                    Can redeem 5 game card NFTs and $299 worth of CDH in-game rewards.
                                </p>
                                <h3 className={styles.ticket_availability}>
                                    100 Currently available
                                </h3>
                                <h3 className={styles.ticket_price}>
                                    <img src={busdIcon} alt="" />
                                    399 BUSD
                                </h3>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} lg={4} className={styles.ticket_col}>
                        <div className={styles.ticket_item}>
                            <div className={styles.ticket_img}>
                                <img src={silverTicket} alt="silver ticket" />
                            </div>
                            <div className={styles.ticket_desc}>
                                <h3 className={styles.ticket_title}>
                                    Silver Ticket
                                </h3>
                                <p className={styles.ticket_info}>
                                    Can redeem 4 game card NFTs and $199 worth of CDH in-game rewards.
                                </p>
                                <h5 className={styles.ticket_availability}>
                                    300 Currently available
                                </h5>
                                <h3 className={styles.ticket_price}>
                                    <img src={busdIcon} alt="" />
                                    299 BUSD
                                </h3>
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} lg={4} className={styles.ticket_col}>
                        <div className={styles.ticket_item}>
                            <div className={styles.ticket_img}>
                                <img src={bronzeTicket} alt="bronze ticket" />
                            </div>
                            <div className={styles.ticket_desc}>
                                <h3 className={styles.ticket_title}>
                                    Bronze Ticket
                                </h3>
                                <p className={styles.ticket_info}>
                                    Can redeem 3 game card NFTs and $99 worth of CDH in-game rewards.
                                </p>
                                <h5 className={styles.ticket_availability}>
                                    600 Currently available
                                </h5>
                                <h3 className={styles.ticket_price}>
                                    <img src={busdIcon} alt="" />
                                    199 BUSD
                                </h3>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export {BinanaceNFTTickets}
